import { eventService } from './eventService'
import { getEventRuntimeConfig } from './runtimeConfig'
import { createGoogleAnalyticsHandler } from './handlers/googleAnalyticsHandler'
import { createLogHandler } from './handlers/logHandler'
import { createTrackUxHandler } from './handlers/trackUxHandler'

let initialized = false

export function initializeEventRuntime() {
  if (initialized || typeof window === 'undefined') {
    return eventService
  }

  const { trackers } = getEventRuntimeConfig()

  if (trackers.googleAnalytics.enabled) {
    eventService.registerHandler(
      createGoogleAnalyticsHandler({
        measurementId: trackers.googleAnalytics.measurementId,
      })
    )
  }

  if (trackers.log.enabled) {
    eventService.registerHandler(createLogHandler())
  }

  if (trackers.trackUx.enabled) {
    eventService.registerHandler(
      createTrackUxHandler({
        projectId: trackers.trackUx.projectId,
        publicKey: trackers.trackUx.publicKey,
        endpoint: trackers.trackUx.endpoint,
        environment: trackers.trackUx.environment,
        debug: trackers.trackUx.debug,
      })
    )
  }

  initialized = true
  return eventService
}
